import groupList from '../views/group/group-list/group-list.vue'
import GroupDetail from '../views/group/group-detail/group-detail'
const group = [
  {
    path: '/grop-list',
    name: 'grop-list',
    component: groupList,
    meta: { keepAlive: true }
  },
  // 拼团详情
  {
    path: '/group-detail',
    name: 'group-detail',
    component: GroupDetail
  }
]
export default group